import { useEffect, useState } from "react";
import { motion } from "motion/react";


const Loader = () => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {

        const interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) {
                    clearInterval(interval);
                    setTimeout(() => { }, 500); // Small delay before hiding
                    return 100;
                }
                return prev + Math.random() * 15 + 5; // Random increment for realistic loading
            });
        }, 100);

        return () => clearInterval(interval);
    }, []);


    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-blue-100"
        >
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-30">
                <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-400/20 rounded-full blur-3xl animate-pulse" />
                <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-blue-600/15 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
                <div className="absolute top-3/4 left-1/2 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }} />
            </div>

            {/* Main Content */}
            <div className="relative z-10 text-center">
                {/* Logo Container */}
                <motion.div
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                    className="mb-8"
                >
                    {/* Glassmorphism Container */}
                    <div className="relative mx-auto w-32 h-32 backdrop-blur-xl bg-white/30 border border-white/20 rounded-3xl shadow-2xl p-6 flex items-center justify-center">
                        {/* Gradient Border Effect */}
                        <div className="absolute inset-0 rounded-3xl bg-gradient-to-r from-blue-500/10 via-transparent to-blue-600/10 blur-sm" />

                        {/* Logo */}
                        <div className="relative z-10">
                            <motion.div
                                animate={{
                                    rotateY: [0, 360],
                                    scale: [1, 1.1, 1]
                                }}
                                transition={{
                                    duration: 2,
                                    repeat: Infinity,
                                    ease: "easeInOut"
                                }}
                                className="text-blue-600"
                            >
                                <img src="/MetaFox_favicon.png" alt="pre-loader" />
                            </motion.div>
                        </div>
                    </div>
                </motion.div>

                {/* Brand Name */}
                <motion.div
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.6, delay: 0.3 }}
                    className="mb-8"
                >
                    <h1 className="text-4xl font-bold bg-gradient-to-r from-blue-600 via-blue-700 to-blue-600 bg-clip-text text-transparent mb-2">
                        MetaFox Tech
                    </h1>
                    <p className="text-black-600 font-medium">Innovating Tomorrow's Solutions</p>
                </motion.div>

                {/* Loading Dots */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1 }}
                    className="flex justify-center space-x-2 mt-6"
                >
                    {[0, 1, 2].map((i) => (
                        <motion.div
                            key={i}
                            className="w-2 h-2 bg-blue-500 rounded-full"
                            animate={{
                                scale: [1, 1.2, 1],
                                opacity: [0.5, 1, 0.5]
                            }}
                            transition={{
                                duration: 1,
                                repeat: Infinity,
                                delay: i * 0.2
                            }}
                        />
                    ))}
                </motion.div>
            </div>
        </motion.div>
    );
}
export default Loader;